import { PageController } from '@client/components/_core/layout/PageController';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/configuration/claims-products/products-v2/details/$productId')({
    params: {
        parse({ productId }) {
            return {
                productId: BigInt(productId),
            };
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <PageController route={Route}>
            <Outlet />
        </PageController>
    );
}
